const API_BASE = '/api/v1/public/projects';
const VSJ_SLUG = 'valor-san-juan';

export interface LocatePlaceDescription {
  streetName: string | null;
  referenceLabel: string | null;
}

export interface LocateLocated {
  status: 'located';
  place: LocatePlaceDescription;
  placeToken: string;
  confirmedGeometry: object | null;
}

export interface LocateOffNetwork {
  status: 'off_network';
}

export type LocateResponse = LocateLocated | LocateOffNetwork;

export async function locatePlace(lng: number, lat: number): Promise<LocateResponse> {
  const res = await fetch(`${API_BASE}/${VSJ_SLUG}/places/locate?lng=${lng}&lat=${lat}`);
  if (!res.ok) throw new Error(`locate: HTTP ${res.status}`);
  return res.json() as Promise<LocateResponse>;
}
